
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"importLoaders\":1}!../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-966f7b10\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!less-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./LumiNavbarLink.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"presets\":[\"latest\"]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./LumiNavbarLink.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-966f7b10\"}!../node_modules/vue-loader/lib/selector?type=template&index=0!./LumiNavbarLink.vue"),
  /* scopeId */
  "data-v-966f7b10",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./components/LumiNavbarLink.vue
// module id = 16
// module chunks = 0